export const diagnosisOptions = [{
        label: "呼吸系统肿瘤",
        options: [{
                label: "肺癌",
                value: "肺癌"
            },
            {
                label: "鼻咽癌",
                value: "鼻咽癌"
            },
        ],
    },
    {
        label: "心血管疾病",
        options: [{
                label: "高血压",
                value: "高血压"
            },
            {
                label: "冠心病",
                value: "冠心病"
            },
            {
                label: "中风",
                value: "中风"
            },
            {
                label: "心肌炎",
                value: "心肌炎"
            },
            {
                label: "心包炎",
                value: "心包炎"
            },
        ],
    },
    {
        label: "内分泌疾病",
        options: [{
                label: "糖尿病",
                value: "糖尿病"
            },
            {
                label: "甲状腺疾病",
                value: "甲状腺疾病"
            },
        ],
    },
    {
        label: "消化系统疾病",
        options: [{
                label: "胃溃疡",
                value: "胃溃疡"
            },
            {
                label: "肝炎",
                value: "肝炎"
            },
            {
                label: "肠癌",
                value: "肠癌"
            },
            {
                label: "肝癌",
                value: "肝癌"
            },
            {
                label: "胰腺癌",
                value: "胰腺癌"
            },
        ],
    },
    {
        label: "神经系统疾病",
        options: [{
                label: "帕金森病",
                value: "帕金森病"
            },
            {
                label: "阿尔茨海默病",
                value: "阿尔茨海默病"
            },
            {
                label: "抑郁症",
                value: "抑郁症"
            },
            {
                label: "焦虑症",
                value: "焦虑症"
            },
        ],
    },
    {
        label: "癌症",
        options: [{
                label: "乳腺癌",
                value: "乳腺癌"
            },
            {
                label: "前列腺癌",
                value: "前列腺癌"
            },
            {
                label: "皮肤癌",
                value: "皮肤癌"
            },
            {
                label: "胃癌",
                value: "胃癌"
            },
            {
                label: "食道癌",
                value: "食道癌"
            },
            {
                label: "宫颈癌",
                value: "宫颈癌"
            },
            {
                label: "卵巢癌",
                value: "卵巢癌"
            },
        ],
    },
    {
        label: "传染病",
        options: [{
                label: "艾滋病",
                value: "艾滋病"
            },
            {
                label: "结核病",
                value: "结核病"
            },
            {
                label: "流感",
                value: "流感"
            },
            {
                label: "水痘",
                value: "水痘"
            },
            {
                label: "麻疹",
                value: "麻疹"
            },
        ],
    },
    {
        label: "风湿免疫疾病",
        options: [{
                label: "类风湿性关节炎",
                value: "类风湿性关节炎"
            },
            {
                label: "骨关节炎",
                value: "骨关节炎"
            },
        ],
    },
    {
        label: "血液系统疾病",
        options: [{
                label: "白血病",
                value: "白血病"
            },
            {
                label: "淋巴瘤",
                value: "淋巴瘤"
            },
        ],
    },
];